/* Kokosnuss · maqueta 2026 */
(function () {
  'use strict';
  var WA = window.KK_WA || '528117985431';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var money = function (n) { return '$' + Math.round(n).toLocaleString('es-MX'); };
  var store = {
    get: function (k, d) { try { var v = localStorage.getItem(k); return v ? JSON.parse(v) : d; } catch (e) { return d; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };

  if (/netlify\.app$/.test(location.hostname)) document.documentElement.classList.add('on-netlify');

  /* ---------- toast ---------- */
  var toastEl = $('[data-toast]'), toastT;
  function toast(msg) {
    toastEl.textContent = msg; toastEl.classList.add('is-on');
    clearTimeout(toastT); toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2400);
  }

  /* ---------- Navidad: días que faltan ---------- */
  (function () {
    var now = new Date(), y = now.getFullYear(), xmas = new Date(y, 11, 25);
    if (now > new Date(y, 11, 25, 23, 59)) xmas = new Date(y + 1, 11, 25);
    var d = Math.max(0, Math.ceil((xmas - new Date(y, now.getMonth(), now.getDate())) / 864e5));
    $$('[data-days]').forEach(function (el) { el.textContent = d; el.removeAttribute('data-count'); });
  })();

  /* ---------- Navidad: ventisca de nieve (viento con ráfagas) ---------- */
  (function () {
    var cv = $('.snow-fixed'); if (!cv || reduce) { if (cv) cv.remove(); return; }
    var ctx = cv.getContext('2d'), W, H, dpr = Math.min(2, window.devicePixelRatio || 1), flakes = [], streaks = [];
    function size() { W = window.innerWidth; H = window.innerHeight; cv.width = W * dpr; cv.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0); }
    size(); window.addEventListener('resize', size);
    var n = Math.round(Math.min(130, Math.max(40, W / 12)));
    function flake(top) { var z = Math.random(); return { x: Math.random() * (W + 200) - 100, y: top ? -10 : Math.random() * H, z: z, r: .8 + z * 2.8, v: .45 + z * 1.3, p: Math.random() * 6.28 }; }
    for (var i = 0; i < n; i++) flakes.push(flake(false));
    var last = 0;
    function draw(t) {
      if (document.hidden) { last = 0; requestAnimationFrame(draw); return; }
      var dt = Math.min(48, t - (last || t)) / 16; last = t;
      // viento: base suave + ráfagas cada tantos segundos
      var gust = Math.max(0, Math.sin(t / 2600)) * Math.max(0, Math.sin(t / 7300 + 1));
      var wind = .5 + gust * 4.2;
      ctx.clearRect(0, 0, W, H);
      for (var i = 0; i < flakes.length; i++) {
        var f = flakes[i];
        f.y += f.v * dt * (1 + gust * .6);
        f.x += (wind * (.4 + f.z) + Math.sin(t / 1400 + f.p) * .5) * dt;
        if (f.y > H + 8 || f.x > W + 60) { var nf = flake(true); if (f.x > W + 60) { nf.x = -40; nf.y = Math.random() * H; } flakes[i] = nf; continue; }
        var a = .55 + f.z * .4;
        ctx.beginPath(); ctx.arc(f.x, f.y, f.r, 0, 6.283);
        ctx.fillStyle = 'rgba(255,255,255,' + a + ')'; ctx.fill();
        ctx.lineWidth = .7; ctx.strokeStyle = 'rgba(120,160,185,' + (.35 + f.z * .3) + ')'; ctx.stroke();
      }
      // rachas de viento: líneas finas que cruzan durante la ráfaga
      if (gust > .45 && Math.random() < .25 * gust) streaks.push({ x: -120, y: Math.random() * H, l: 60 + Math.random() * 120, s: 14 + Math.random() * 10, a: .25 + Math.random() * .2 });
      for (var k = streaks.length - 1; k >= 0; k--) {
        var s = streaks[k]; s.x += s.s * dt; s.y += .8 * dt;
        var g = ctx.createLinearGradient(s.x, s.y, s.x + s.l, s.y + 6);
        g.addColorStop(0, 'rgba(160,195,215,0)'); g.addColorStop(.5, 'rgba(160,195,215,' + s.a + ')'); g.addColorStop(1, 'rgba(160,195,215,0)');
        ctx.strokeStyle = g; ctx.lineWidth = 1.2; ctx.beginPath(); ctx.moveTo(s.x, s.y); ctx.lineTo(s.x + s.l, s.y + 6); ctx.stroke();
        if (s.x > W + 40) streaks.splice(k, 1);
      }
      requestAnimationFrame(draw);
    }
    requestAnimationFrame(draw);
  })();

  /* ---------- carga y header ---------- */
  window.addEventListener('load', function () { document.body.classList.add('is-loaded'); });
  setTimeout(function () { document.body.classList.add('is-loaded'); }, 1800);
  var hdr = $('.hdr');
  var onScrollHdr = function () { hdr.classList.toggle('is-scrolled', window.scrollY > 40); };
  window.addEventListener('scroll', onScrollHdr, { passive: true }); onScrollHdr();

  /* ---------- menú móvil ---------- */
  var burger = $('.burger'), mmenu = $('#mmenu');
  function setMenu(open) {
    burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    burger.setAttribute('aria-label', open ? 'Cerrar menú' : 'Abrir menú');
    if (open) { mmenu.hidden = false; requestAnimationFrame(function () { mmenu.classList.add('is-open'); }); document.body.style.overflow = 'hidden'; }
    else { mmenu.classList.remove('is-open'); mmenu.hidden = true; document.body.style.overflow = ''; }
  }
  burger.addEventListener('click', function () { setMenu(burger.getAttribute('aria-expanded') !== 'true'); });
  $$('a', mmenu).forEach(function (a) { a.addEventListener('click', function () { setMenu(false); }); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { if (!mmenu.hidden) setMenu(false); closeQuote(); } });
  window.addEventListener('resize', function () { if (window.innerWidth > 1180 && !mmenu.hidden) setMenu(false); });

  /* ---------- titular por líneas ---------- */
  $$('[data-split] .ln').forEach(function (ln) { var s = document.createElement('span'); while (ln.firstChild) s.appendChild(ln.firstChild); ln.appendChild(s); });
  requestAnimationFrame(function () { setTimeout(function () { $$('[data-split]').forEach(function (h) { h.classList.add('is-in'); }); }, 120); });

  /* ---------- aparecer al hacer scroll ---------- */
  if ('IntersectionObserver' in window && !reduce) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target, sibs = $$('.reveal:not(.is-in)', el.parentElement);
        var i = Math.max(0, sibs.indexOf(el));
        el.style.transitionDelay = Math.min(i * 70, 350) + 'ms';
        el.classList.add('is-in'); io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    $$('.reveal').forEach(function (el) { io.observe(el); });
  } else { $$('.reveal').forEach(function (el) { el.classList.add('is-in'); }); }

  /* ---------- contadores ---------- */
  $$('[data-count]').forEach(function (el) {
    if (reduce || !('IntersectionObserver' in window)) return;
    var end = +el.getAttribute('data-count'), pre = el.getAttribute('data-prefix') || '';
    el.textContent = pre + '0';
    var o = new IntersectionObserver(function (en) {
      if (!en[0].isIntersecting) return; o.disconnect();
      var t0 = performance.now(), d = 1400;
      (function tick(t) { var p = Math.min(1, (t - t0) / d), e = 1 - Math.pow(1 - p, 3); el.textContent = pre + Math.round(end * e); if (p < 1) requestAnimationFrame(tick); })(t0);
    });
    o.observe(el);
  });

  /* ---------- botones magnéticos ---------- */
  if (!reduce && window.matchMedia('(hover: hover)').matches) {
    $$('.magnetic').forEach(function (b) {
      b.addEventListener('mousemove', function (e) { var r = b.getBoundingClientRect(); b.style.transform = 'translate(' + ((e.clientX - r.left - r.width / 2) * 0.18) + 'px,' + ((e.clientY - r.top - r.height / 2) * 0.28) + 'px)'; });
      b.addEventListener('mouseleave', function () { b.style.transform = ''; });
    });
  }

  /* ---------- destellos dorados en el hero ---------- */
  (function () {
    var cv = $('.sparkle'); if (!cv || reduce) return;
    var ctx = cv.getContext('2d'), pts = [], W, H, dpr = Math.min(2, window.devicePixelRatio || 1), run = true;
    function size() { W = cv.offsetWidth; H = cv.offsetHeight; cv.width = W * dpr; cv.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0); }
    size(); window.addEventListener('resize', size);
    var n = Math.round(Math.min(70, W / 18));
    for (var i = 0; i < n; i++) pts.push({ x: Math.random() * W, y: Math.random() * H, r: Math.random() * 1.8 + .4, s: Math.random() * .25 + .05, p: Math.random() * 6.28 });
    var hero = $('.hero');
    new IntersectionObserver(function (en) { run = en[0].isIntersecting; if (run) requestAnimationFrame(draw); }).observe(hero);
    function draw(t) {
      if (!run) return;
      ctx.clearRect(0, 0, W, H);
      pts.forEach(function (p) {
        p.y -= p.s; if (p.y < -5) { p.y = H + 5; p.x = Math.random() * W; }
        var a = .25 + .55 * Math.abs(Math.sin(t / 900 + p.p));
        ctx.beginPath(); ctx.fillStyle = 'rgba(226,196,142,' + a + ')'; ctx.arc(p.x, p.y, p.r, 0, 6.283); ctx.fill();
        if (p.r > 1.7) { ctx.fillStyle = 'rgba(226,196,142,' + a * .25 + ')'; ctx.fillRect(p.x - p.r * 3, p.y - .3, p.r * 6, .6); ctx.fillRect(p.x - .3, p.y - p.r * 3, .6, p.r * 6); }
      });
      requestAnimationFrame(draw);
    }
  })();

  /* ---------- carril "para quién" ---------- */
  var rail = $('.who-rail');
  $$('[data-scroll]').forEach(function (b) {
    b.addEventListener('click', function () { var card = $('.who-card', rail); rail.scrollBy({ left: (+b.getAttribute('data-scroll')) * (card.offsetWidth + 16), behavior: reduce ? 'auto' : 'smooth' }); });
  });

  /* ---------- colección: filtros ---------- */
  var cards = $$('.card'), chips = $$('.chip'), noAlc = $('[data-noalcohol]'), moreBtn = $('[data-more]'), emptyEl = $('[data-empty]');
  var range = 'all', expanded = false;
  function inRange(p) {
    if (range === 'all') return true;
    if (range === '1000') return p < 1000;
    if (range === '3000') return p >= 3000 || false;
    var a = range.split('-'); return p >= +a[0] && p < +a[1];
  }
  function maxPrice(c) { var m = (c.querySelector('.opt') || {}).textContent || ''; var nums = (m.match(/\$[\d,]+/g) || []).map(function (s) { return +s.replace(/[$,]/g, ''); }); return Math.max.apply(null, [+c.dataset.price].concat(nums)); }
  function applyFilter() {
    if (!noAlc || !emptyEl || !moreBtn) return;
    var filtering = range !== 'all' || noAlc.checked, shown = 0;
    cards.forEach(function (c) {
      var p = +c.dataset.price, ok = (inRange(p) || (range === '3000' && maxPrice(c) >= 3000)) && (!noAlc.checked || c.dataset.alc === '0');
      c.classList.toggle('is-hidden', !ok);
      c.classList.toggle('is-collapsed', c.classList.contains('more') && !filtering && !expanded);
      if (ok) { shown++; c.classList.remove('pop'); void c.offsetWidth; if (!reduce) c.classList.add('pop'); }
    });
    emptyEl.hidden = shown > 0;
    moreBtn.parentElement.hidden = filtering || expanded;
  }
  chips.forEach(function (ch) {
    ch.addEventListener('click', function () {
      range = ch.dataset.filter;
      chips.forEach(function (x) { var on = x === ch; x.classList.toggle('is-on', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      applyFilter();
    });
  });
  if (noAlc) noAlc.addEventListener('change', applyFilter);
  if (moreBtn) moreBtn.addEventListener('click', function () { expanded = true; applyFilter(); });
  $$('[data-filter-go]').forEach(function (a) {
    a.addEventListener('click', function () { var ch = $('.chip[data-filter="' + a.dataset.filterGo + '"]'); if (ch) ch.click(); });
  });
  applyFilter();

  /* ---------- cotización ---------- */
  var quote = store.get('kk_quote', []);
  var drawer = $('[data-drawer]'), dList = $('[data-drawer-list]'), dTotal = $('[data-drawer-total]'), qBtn = $('.quote-btn'), qCount = $('[data-quote-count]');
  function cardById(id) { return $('.card[data-id="' + id + '"]'); }
  function total() { return quote.reduce(function (s, q) { return s + q.price * q.qty; }, 0); }
  function waText() {
    var lines = ['Hola Kokosnuss, ya vi el catálogo y quiero cotizar regalos de Navidad.'];
    if (quote.length) { lines.push('', 'Mi lista:'); quote.forEach(function (q) { lines.push('- ' + q.qty + ' x ' + q.name + ' (desde ' + money(q.price) + ' c/u)'); }); lines.push('Estimado: ' + money(total()) + ' + IVA'); }
    lines.push('', 'Fecha de entrega: ');
    return 'https://wa.me/' + WA + '?text=' + encodeURIComponent(lines.join('\n'));
  }
  function render() {
    store.set('kk_quote', quote);
    var n = quote.reduce(function (s, q) { return s + q.qty; }, 0);
    qCount.textContent = quote.length; qBtn.classList.toggle('has-items', quote.length > 0);
    qBtn.setAttribute('aria-label', 'Abrir mi cotización: ' + quote.length + ' regalos, ' + n + ' piezas');
    cards.forEach(function (c) {
      var inQ = quote.some(function (q) { return q.id === c.dataset.id; }), b = $('[data-add]', c);
      b.classList.toggle('is-added', inQ); b.innerHTML = inQ ? 'Agregado <span aria-hidden="true">✓</span>' : 'Agregar <span aria-hidden="true">+</span>';
    });
    dList.innerHTML = '';
    if (!quote.length) dList.innerHTML = '<li class="empty-d">Aún no agregas regalos. Elige en la colección y ajusta las piezas aquí.</li>';
    quote.forEach(function (q) {
      var li = document.createElement('li'); li.className = 'd-item';
      li.innerHTML = '<img alt="" src="' + q.img + '"><div><h3></h3><p>' + money(q.price) + ' c/u · ' + money(q.price * q.qty) + '</p><button class="rm" type="button">Quitar</button></div>' +
        '<div class="qty"><button type="button" aria-label="Menos">−</button><input type="number" inputmode="numeric" min="' + q.min + '" value="' + q.qty + '" aria-label="Piezas de ' + q.name + '"><button type="button" aria-label="Más">+</button></div>';
      $('h3', li).textContent = q.name;
      var inp = $('input', li), bt = $$('.qty button', li);
      var setQ = function (v) { q.qty = Math.max(q.min, Math.min(5000, parseInt(v, 10) || q.min)); render(); };
      bt[0].addEventListener('click', function () { setQ(q.qty - 1); });
      bt[1].addEventListener('click', function () { setQ(q.qty + 1); });
      inp.addEventListener('change', function () { setQ(inp.value); });
      $('.rm', li).addEventListener('click', function () { quote = quote.filter(function (x) { return x !== q; }); render(); });
      dList.appendChild(li);
    });
    dTotal.textContent = money(total());
    // resumen en la sección de WhatsApp
    var sl = $('[data-summary-list]'), st = $('[data-summary-total]');
    if (!sl || !st) { /* sin sección de WhatsApp */ } else if (quote.length) {
      sl.innerHTML = '';
      quote.forEach(function (q) { var li = document.createElement('li'); li.innerHTML = '<span></span><span>' + q.qty + ' pzas</span>'; li.firstChild.textContent = q.name; sl.appendChild(li); });
      st.hidden = false; st.innerHTML = '<span>Estimado + IVA</span><span>' + money(total()) + '</span>';
    } else {
      sl.innerHTML = '<li class="muted">Aún no agregas regalos. Puedes escribirnos sin elegir, o <a href="#coleccion">ver la colección</a>.</li>';
      st.hidden = true;
    }
    $$('[data-wa-quote]').forEach(function (a) { a.href = waText(); });
  }
  cards.forEach(function (c) {
    $('[data-add]', c).addEventListener('click', function () {
      var id = c.dataset.id, ex = quote.filter(function (q) { return q.id === id; })[0];
      if (ex) { openQuote(); return; }
      var min = +c.dataset.min || 1;
      quote.push({ id: id, name: c.dataset.name, price: +c.dataset.price, min: min, qty: Math.max(min, 10), img: $('img', c).getAttribute('src').replace('-1600', '-800') });
      render(); toast(c.dataset.name + ' agregado a tu cotización');
      qBtn.classList.add('bump'); setTimeout(function () { qBtn.classList.remove('bump'); }, 400);
      try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('kokosnuss_add_quote', { id: id, price: +c.dataset.price }); } catch (e) {}
    });
  });
  var lastFocus;
  function openQuote() { lastFocus = document.activeElement; drawer.hidden = false; requestAnimationFrame(function () { drawer.classList.add('is-open'); }); document.body.style.overflow = 'hidden'; setTimeout(function () { $('.x', drawer).focus(); }, 60); }
  function closeQuote() { if (drawer.hidden) return; drawer.classList.remove('is-open'); document.body.style.overflow = ''; setTimeout(function () { drawer.hidden = true; }, 450); if (lastFocus) lastFocus.focus(); }
  $$('[data-open-quote]').forEach(function (b) { b.addEventListener('click', openQuote); });
  $$('[data-close-quote]').forEach(function (b) { b.addEventListener('click', closeQuote); });
  render();

  /* ---------- galería fija con scroll horizontal (escritorio) ---------- */
  (function () {
    var pin = $('.pin'), track = $('[data-track]');
    if (!pin || !track) return;
    var mq = window.matchMedia('(min-width: 1024px) and (min-height: 640px)');
    var dist = 0;
    function setup() {
      pin.classList.remove('is-pinned'); pin.style.removeProperty('--pin-h'); track.style.transform = '';
      if (reduce || !mq.matches) return;
      pin.classList.add('is-pinned');
      dist = Math.max(0, track.scrollWidth - window.innerWidth);
      pin.style.setProperty('--pin-h', (window.innerHeight + dist) + 'px');
      onScroll();
    }
    function onScroll() {
      if (!pin.classList.contains('is-pinned')) return;
      var r = pin.getBoundingClientRect(), p = Math.min(1, Math.max(0, -r.top / (pin.offsetHeight - window.innerHeight || 1)));
      track.style.transform = 'translate3d(' + (-dist * p) + 'px,0,0)';
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', setup);
    window.addEventListener('load', setup); setup();
    // arrastrar con mouse cuando no está fijo
    var down = false, sx = 0, sl = 0;
    track.addEventListener('mousedown', function (e) { if (pin.classList.contains('is-pinned')) return; down = true; sx = e.pageX; sl = track.scrollLeft; });
    window.addEventListener('mouseup', function () { down = false; });
    track.addEventListener('mousemove', function (e) { if (!down) return; e.preventDefault(); track.scrollLeft = sl - (e.pageX - sx); });
  })();

  /* ---------- parallax y línea de proceso ---------- */
  var par = reduce ? [] : $$('.parallax'), line = $('.proc-line span'), steps = $('.steps');
  function onScrollFx() {
    var vh = window.innerHeight;
    par.forEach(function (el) { var r = el.getBoundingClientRect(); if (r.bottom < 0 || r.top > vh) return; el.style.transform = 'translate3d(0,' + ((r.top + r.height / 2 - vh / 2) * +el.dataset.speed) + 'px,0)'; });
    if (line && steps) { var r = steps.getBoundingClientRect(); line.parentElement.style.setProperty('--p', Math.min(1, Math.max(0, (vh * .85 - r.top) / (r.height + vh * .3))).toFixed(3)); }
  }
  window.addEventListener('scroll', onScrollFx, { passive: true }); onScrollFx();

  /* ---------- menú activo ---------- */
  var navLinks = $$('.nav a');
  if ('IntersectionObserver' in window) {
    var nio = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) navLinks.forEach(function (a) { a.classList.toggle('is-active', a.getAttribute('href') === '#' + e.target.id); }); });
    }, { rootMargin: '-45% 0px -50% 0px' });
    navLinks.forEach(function (a) { var h = a.getAttribute('href'); if (h.charAt(0) !== '#') return; var s = $(h); if (s) nio.observe(s); });
  }

  /* ---------- clics a WhatsApp (manual: Shopify.analytics.publish -> Meta Contact / GA4 generate_lead) ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href*="wa.me/"], a[href*="api.whatsapp.com"], [data-wa]');
    if (!a) return;
    var method = /wa\.me|whatsapp\.com/.test(a.href || '') ? 'whatsapp' : 'agenda';
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('cliente_lead', { method: method, origen: a.getAttribute('data-wa') || 'enlace', pagina: location.pathname }); } catch (err) {}
  });

  /* ---------- clics al catálogo (Meta: ViewContent / GA4: ver_catalogo) ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-catalog]'); if (!a) return;
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('ver_catalogo', { origen: a.getAttribute('data-catalog'), pagina: location.pathname }); } catch (err) {}
  });

  /* ---------- cookies ---------- */
  var ck = $('[data-cookies]'), ckOpts = $('[data-ck-opts]');
  function saveConsent(an, mk) {
    store.set('kk_consent', { analytics: an, marketing: mk, t: Date.now() });
    try { if (window.Shopify && Shopify.customerPrivacy) Shopify.customerPrivacy.setTrackingConsent({ analytics: an, marketing: mk, preferences: an, sale_of_data: mk }, function () {}); } catch (e) {}
    ck.hidden = true;
  }
  if (!store.get('kk_consent', null)) setTimeout(function () { ck.hidden = false; }, 1200);
  $('[data-ck-accept]').addEventListener('click', function () {
    if (!ckOpts.hidden) saveConsent($('[data-ck="analytics"]').checked, $('[data-ck="marketing"]').checked); else saveConsent(true, true);
  });
  $('[data-ck-reject]').addEventListener('click', function () { saveConsent(false, false); });
  $('[data-ck-config]').addEventListener('click', function () { ckOpts.hidden = !ckOpts.hidden; $('[data-ck-accept]').textContent = ckOpts.hidden ? 'Aceptar' : 'Guardar'; });
  $('[data-cookie-open]').addEventListener('click', function () { var c = store.get('kk_consent', {}); $('[data-ck="analytics"]').checked = !!c.analytics; $('[data-ck="marketing"]').checked = !!c.marketing; ckOpts.hidden = false; $('[data-ck-accept]').textContent = 'Guardar'; ck.hidden = false; });
})();
